<template>
  <div class="articles-contributors">
    <AnalysisTable v-for="cmp of cmps" :key="cmp.id" v-bind="cmp" />
  </div>
</template>

<script>
import AnalysisTable from './AnalysisTable'
import { authContrCols, journContrCols, subAreasContrCols, publContrCols } from './table-cols'

export default {
  components: {
    AnalysisTable
  },

  props: {
    data: Object
  },

  computed: {
    cmps() {
      return [
        {
          id: 1,
          title: 'Journals with most contributions',
          columns: journContrCols,
          data: this.data.journals_with_most_contributions
        },
        {
          id: 2,
          title: 'Subject areas with most contributions',
          columns: subAreasContrCols,
          data: this.data.subject_areas_with_most_contributions
        },
        {
          id: 3,
          title: 'Corresponding authors with most contributions',
          columns: authContrCols,
          data: this.data.corresponding_authors_with_most_contributions
        },
        {
          id: 4,
          title: 'Corresponding publishers with most contributions',
          columns: publContrCols,
          data: this.data.publishers_with_most_contributions
        }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.articles-contributors {
  display grid
  grid-column 1/-1
  grid-template-columns repeat(2, 1fr)
  gap 20px
}

@media only screen and (max-width: 1280px) {
  .articles-contributors {
    display contents
  }
}
</style>
